import {React, useEffect, useState} from 'react';
import {Box, Typography, Button} from '@mui/material'
import AxiosInstance from './axios';
import {useNavigate, useParams} from 'react-router-dom'

const Delete = () => {
    
}

export default Delete